var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  }

  return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
var s = {
  printRender: 'easy-print-PrintProvider-printRender-S70b',
  hiddenAll: 'easy-print-PrintProvider-hiddenAll-1V_W',
  wrap: 'easy-print-PrintProvider-wrap-21G8',
  _loose: 'easy-print-PrintProvider-_loose-2eYz',
  _invert: 'easy-print-PrintProvider-_invert-1m-C'
};

require('load-styles')('/*  imported from PrintProvider.css  */\n\n@media print {\n  .easy-print-PrintProvider-printRender-S70b {\n    width: 100%;\n    background-color: #fff;\n    z-index: 10000000;\n    height: 100vh;\n    position: absolute;\n    top: 0;\n    left: 0\n  }\n  .easy-print-PrintProvider-hiddenAll-1V_W {\n    visibility: hidden ;\n  }\n  .easy-print-PrintProvider-hiddenAll-1V_W .react-easy-print-print {\n    visibility: hidden;\n  }\n  .easy-print-PrintProvider-wrap-21G8.easy-print-PrintProvider-_loose-2eYz:not(.easy-print-PrintProvider-_invert-1m-C) {\n    visibility: hidden;\n  }\n}\n');

import { spliced, debug } from './common';
export var propTypes = {
  loose: PropTypes.bool,
  children: PropTypes.node.isRequired,
  invert: PropTypes.bool
};
export var childContextTypes = {
  printProvider: PropTypes.shape({
    regPrintable: PropTypes.func.isRequired,
    unregPrintable: PropTypes.func.isRequired,
    isPrint: PropTypes.bool.isRequired
  }).isRequired
};

var PrintProvider = function (_React$PureComponent) {
  _inherits(PrintProvider, _React$PureComponent);

  function PrintProvider(props) {
    _classCallCheck(this, PrintProvider);

    var _this = _possibleConstructorReturn(this, (PrintProvider.__proto__ || Object.getPrototypeOf(PrintProvider)).call(this, props));

    _this.state = {
      isInPrintPreview: false,
      printableNodes: []
    };
    _this.printableRegistry = {};

    window.matchMedia('print').onchange = function () {
      debug('toggle print mode', window.matchMedia('print').matches);

      _this.setState({
        isInPrintPreview: window.matchMedia('print').matches
      });
    };

    _this.hasSingle = false;
    return _this;
  }

  _createClass(PrintProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        printProvider: {
          isPrint: window.matchMedia('print').matches,
          regPrintable: this.regPrintable.bind(this),
          unregPrintable: this.unregPrintable.bind(this)
        }
      };
    } // hideAll - is being used to cover all of React Portals, popups and modals and etc.

  }, {
    key: 'hideAll',
    value: function hideAll() {
      document.body.classList.add(s.hiddenAll);
      this.hasSingle = true;
    }
  }, {
    key: 'unhideAll',
    value: function unhideAll() {
      document.body.classList.remove(s.hiddenAll);
      this.hasSingle = false;
    }
  }, {
    key: 'regPrintable',
    value: function regPrintable(key, node) {
      var _this2 = this;

      var loose = this.props.loose || this.props.invert;
      var isSingle = node.props.single || node.props.main;
      var hasSingle = this.hasSingle;
      debug('reg printable', key, node);
      if (this.printableRegistry[key] !== undefined || loose) return;
      setTimeout(function () {
        return _this2.setState({
          printableNodes: _this2.state.printableNodes.concat(node)
        });
      }, 0);
      this.printableRegistry[key] = this.state.printableNodes.length;

      if (isSingle && !hasSingle) {
        this.hideAll();
      } else if (isSingle) {
        console.warn(new Error('react-easy-print warning \n\t you\'re using more than one `single` Print component'));
      }
    }
  }, {
    key: 'unregPrintable',
    value: function unregPrintable(key, isSingle) {
      var loose = this.props.loose || this.props.invert;
      if (this.printableRegistry[key] === undefined || this.state.isInPrintPreview || loose) return;
      this.setState({
        printableNodes: spliced(this.state.printableNodes, this.printableRegistry[key])
      });
      this.printableRegistry = Object.assign({}, this.printableRegistry, _defineProperty({}, key, undefined));

      if (isSingle) {
        this.unhideAll();
      }
    }
  }, {
    key: 'createRender',
    value: function createRender(children) {
      var el = document.createElement('div');
      el.id = 'render';
      document.body.appendChild(el);
      ReactDOM.render(React.createElement('div', {
        className: s.printRender
      }, children), el);
    }
  }, {
    key: 'deleteRender',
    value: function deleteRender() {
      var el = document.getElementById('render');
      el && document.body.removeChild(el);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          isInPrintPreview = _state.isInPrintPreview,
          printableNodes = _state.printableNodes;
      var loose = this.props.loose || this.props.invert;
      var hasSingle = this.hasSingle;

      if (isInPrintPreview && printableNodes.length && !loose && !hasSingle) {
        debug('render printable only', printableNodes);
        var children = React.Children.map(printableNodes, function (child, key) {
          return React.cloneElement(child, {
            key: key
          });
        });
        this.createRender(React.createElement('div', null, children));
      }

      setTimeout(function () {
        return _this3.deleteRender();
      }, 0);
      debug('render everything', isInPrintPreview, printableNodes.length, !loose);
      var loose_ = loose ? s.loose : '';
      var invert_ = this.props.invert ? s.invert : '';
      return React.createElement('div', {
        className: s.wrap + ' ' + loose_ + ' ' + invert_ + ' '
      }, this.props.children);
    }
  }]);

  return PrintProvider;
}(React.PureComponent);

export default PrintProvider;
PrintProvider.childContextTypes = childContextTypes;